#widgetFrame {
  display: flex;
  height: 100%;
}

se-dialog-content {
  display: flex;
  flex: 1;
}

.sc-selector-modal-header {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  padding: 20px 15px 10px;
}

.sc-selector-modal-controls {
  display: flex;
  flex-direction: row;
  gap: 10px;
}

.sc-selector-modal-controls pes-icon {
  cursor: pointer;
}

.sc-selector-modal-controls .button-close {
  position: initial;
}

.header-label {
  font-size: 2em;
  font-weight: 400;
  line-height: 1.5em;
  margin: 0;
}

:host(:not([dir="rtl"])) .header-label {
  padding-right: 30px;
}

:host([dir="rtl"]) .header-label {
  padding-left: 30px;
}

.header-label .highlight-naming {
  font-weight: 400;
}

.header-label .highlight-naming .accent {
  font-weight: 700;
}

expand-button {
  display: none;
}

.button-close {
  padding: 0;
  background-color: transparent;
  border: none;
  outline: none;
  cursor: pointer;
  font-family: inherit;
}

.icon-close {
  background-image: url("data:image/svg+xml,%3C%3Fxml version='1.0' encoding='UTF-8'%3F%3E%3Csvg viewBox='0 0 19 19' version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink'%3E%3Cpath fill='%239FA0A4' fill-rule='evenodd' d='M13.1 13.1c-.28.28-.74.28-1.02 0l-2.7-2.68-2.8 2.8c-.28.3-.74.3-1.02 0a.7.7 0 0 1 0-1l2.8-2.83L5.7 6.7c-.3-.27-.3-.73 0-1 .27-.3.73-.3 1 0l2.7 2.67 2.55-2.55c.28-.3.74-.3 1.02 0 .28.28.28.73 0 1.02L10.42 9.4l2.68 2.68c.28.28.28.74 0 1.02m2.94-10.35c-3.66-3.67-9.63-3.67-13.3 0-3.66 3.66-3.66 9.62 0 13.3 3.67 3.65 9.63 3.65 13.3 0 3.66-3.68 3.66-9.64 0-13.3'%3E%3C/path%3E%3C/svg%3E");
  height: 18px;
  width: 18px;
}

@media only screen and (max-width: 979px) {
  #iframeWidget {
    border: none;
    border-top: 2px solid #3dcd58;
  }
}

@media screen and (min-width: 980px) {
  .header-label {
    font-size: 35px;
  }

  expand-button {
    display: block;
    cursor: pointer;
    color: #9fa0a4;
  }

  :host(:not([dir="rtl"])) expand-button {
    border-right: 1px solid;
    margin-right: 16px;
    padding-right: 16px;
  }

  :host([dir="rtl"]) expand-button {
    border-left: 1px solid;
    margin-left: 16px;
    padding-left: 16px;
  }

  .sc-selector-modal-header {
    padding-bottom: 0;
  }
}